import {NgModule} from '@angular/core';

import {MdcTabIndicatorModule} from '@shraddhar/mdc-test-web/tab-indicator';
import {MdcTabModule} from '@shraddhar/mdc-test-web/tab';
import {MdcTabScrollerModule} from '@shraddhar/mdc-test-web/tab-scroller';

import {MdcTabBar} from './tab-bar';

@NgModule({
  imports: [
    MdcTabIndicatorModule,
    MdcTabModule,
    MdcTabScrollerModule
  ],
  exports: [
    MdcTabBar,
    MdcTabIndicatorModule,
    MdcTabModule,
    MdcTabScrollerModule
  ],
  declarations: [MdcTabBar]
})
export class MdcTabBarModule { }
